// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.order.CreateContactLensTrialOrderBasicRequest */
/* istanbul ignore next */
@GandalfModel
export class CreateContactLensTrialOrderBasicRequest extends GandalfModelBase {

	@GandalfLabel('Contact Lens Prescription')
	@GandalfProperty({ designType: Number })
	contactLensPrescriptionId!: number | null;

	@GandalfLabel('Contact Lens Trial')
	@GandalfProperty({ designType: Number })
	contactLensTrialId!: number | null;

	@GandalfLabel('Patient')
	@GandalfValidator({ notNull: { message: 'Patient is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	patientId!: number;

}
